<template>
  <b-modal id="screening1Modal" size="lg" centered modal-class="content-modal" no-stacking no-close-on-backdrop hide-footer @shown="modalShown">
    <template #modal-header="{ close }">
      <div class="modal-close-button">
        <b-button variant="close-button" title="Close modal pop up" @click="close()"></b-button>
      </div>
      <h3 class="modal-title h-underline" id="screening1ModalLabel">I’m fit and healthy – I don’t think I’m at risk of developing cancer</h3>
    </template>

    <b-row>
      <b-col md="12">
        <p>Play the video to find out the advice from a nurse.</p>
        <VideoArea :video="video1"></VideoArea>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import VideoArea from "../../components/VideoArea";

export default {
  name: "Screening1",

  components: {
    VideoArea,
  },

  methods: {
    modalShown() {
      this.$emit("opened", 4);
    },
  },

  data: function() {
    return {
      video1: {
        id: 1,
        source: {
          plain: "./media/screeningforcancer/screening1/screening1.mp4",
        },
        captions: "./media/screeningforcancer/screening1/screening1-captions.vtt",
        poster: "./media/screeningforcancer/screening1/screening1-thumbnail.jpg",
      },
    };
  },
};
</script>
